<template>
    <div class="maintenance">
      <div class="content">
        <div class="logo-box__logo mb-4">
            <img src="@/assets/img/cyberclass.svg" alt="CyberClass" class="d-none d-md-inline-block logo-box__logo__img" />
            <img height="35" src="@/assets/img/logo-icone.png" class="d-inline-block d-md-none" alt="CyberClass" />
        </div>
        <h1>Estamos em manutenção</h1>
        <p>Estamos realizando algumas melhorias para oferecer a melhor experiência possível. Voltamos em breve!</p>
        <button @click="goHome">Voltar para a Home</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    methods: {
      goHome() {
        this.$router.push({ name: 'home' });
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .maintenance {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    text-align: center;
    padding: 20px;
    animation: fadeIn 0.8s ease-in-out;
  
    .content {
      max-width: 500px;
  
      .logo {
        max-width: 120px;
        margin-bottom: 20px;
      }
  
      h1 {
        font-size: 2rem;
        margin-bottom: 10px;
        color: #ff8000
      }
  
      p {
        font-size: 1.2rem;
        margin-bottom: 20px;
      }
  
      button {
        background: #ff8000;
        color: white;
        border: none;
        padding: 12px 20px;
        font-size: 1rem;
        font-weight: bold;
        cursor: pointer;
        border-radius: 5px;
        transition: 0.3s;
        
        &:hover {
          background: rgba(255, 128, 0, 0.8);
        }
      }
    }
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  </style>
  